// extracted by mini-css-extract-plugin
module.exports = {"container":"page-not-found_container__/eXSd","title":"page-not-found_title__OoEyH","message":"page-not-found_message__C0Zmc"};